export default {
    computed: {
        //计费值来源
        getSourcesType(){
            return [{
                value:'FIXED',
                label: this.$t('fbb.accountmanage.fixed_value', { defaultValue: '固定值' })
            },{
                value:'MANUAL',
                label: this.$t('fbb.accountmanage.manual_input', { defaultValue: '手工录入' })
            }]
        },
         //状态
         getStatus(){
            return [{
                value:'STATUS_ACTIVE',
                label: this.$t('fbb.accountmanage.active', { defaultValue: '激活' })
            },{
                value:'STATUS_INACTIVE',
                label: this.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' })
            }]
        },
    },
}